import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService, fromSecondsToMilliseconds } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class SgaLoginConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getAppNotOpenedWarningEnabled(): boolean {
		return this.service.get((x) => x.matCoreUi.sgaLogin.appNotOpenedWarningEnabled, true);
	}

	getAppNotOpenedTimeout(): number {
		return this.service.get((x) => x.matCoreUi.sgaLogin.appNotOpenedTimeout, fromSecondsToMilliseconds(5));
	}
}
